import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

/* =================================
   BOOTSTRAP
================================= */
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import './assets/fonts/fonts.css'

/* =================================
   AXIOS (globale)
================================= */
import axios from 'axios'

import VueMeta from 'vue-meta'

/* =================================
   VEE-VALIDATE (Vue 2 - v3)
================================= */
import {
  ValidationProvider,
  ValidationObserver,
  extend
} from 'vee-validate'

import {
  required,
  email,
  min,
  max
} from 'vee-validate/dist/rules'
Vue.use(VueMeta)
Vue.prototype.$axios = axios

// Registrazione regole
extend('required', {
  ...required,
  message: 'Attenzione! Il campo {_field_} è obbligatorio.'
})

extend('email', {
  ...email,
  message: 'La mail inserita non sembra corretta.'
})

extend('min', {
  ...min,
  message: 'Il campo deve avere almeno {length} caratteri'
})

extend('max', {
  ...max,
  message: 'Il campo non può superare {length} caratteri'
})

// Registrazione globale componenti
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

/* =================================
   CONFIG
================================= */
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
